import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { faShare } from '@fortawesome/free-solid-svg-icons'

import Button from '../../atoms/Button/Button'
import Icon from '../../atoms/Icon'
import IconButton from '../../atoms/Button/IconButton'

// TODO: move these styled components to atoms
const Confirmation = styled(Button).attrs({
  as: 'div',
  type: 'gray700',
  outline: true,
  children: 'Link Copied',
})`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  min-width: 120px;
`

const Container = styled.div`
  position: relative;
`

export default props => {
  const { location = {} } = typeof window === 'undefined' ? {} : window
  const [href, setHref] = useState()
  const [copied, setCopied] = useState()

  useEffect(() => {
    setHref(location.href)
  }, [location.href])

  const handleCopy = () => {
    setCopied(true)
    setTimeout(() => setCopied(), 3000)
  }

  return (
    <CopyToClipboard text={href} onCopy={handleCopy}>
      <Container>
        <IconButton outline {...props} style={{ position: 'relative' }}>
          <Icon icon={faShare} />
        </IconButton>
        {copied ? <Confirmation /> : null}
      </Container>
    </CopyToClipboard>
  )
}
